import { User } from "./user";
import { Therapist } from './therapist';
import { TherapistSchedule } from './therapist_schedule';
import { Card } from './card';
import {Test} from "./test";
import {TestAnswer} from "./test_answer";
import {TestQuestion} from "./test_question";
import {TestUser} from "./test_user";
import {TestUserAnswer} from "./test_user_answer";
import {TestResult} from "./test_result";
import {Plan} from "./plan";
import {Plan_subscription} from "./plan_subscription";
import {Payment} from "./payment";
import {Banner} from "./banner";
import {Config} from "./config";
import {Certification} from "./certification";
import {Association} from "./association";
import { Translate } from './translate';
import {Center} from "./center";
import {CenterUser} from "./center_user";


export const Models = {
    user: User,
    therapist: Therapist,
    therapist_schedule: TherapistSchedule,
    card: Card,
    test: Test,
    test_answer: TestAnswer,
    test_question: TestQuestion,
    test_user: TestUser,
    test_user_answer: TestUserAnswer,
    test_result: TestResult,
    plan: Plan,
    plan_subscription: Plan_subscription,
    payment: Payment,
    banner: Banner,
    config: Config,
    certification: Certification,
    association: Association,
    translate: Translate,
    center: Center,
    center_user: CenterUser
};
